var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#A7A7A7",
    transform: "translate(-917 -393) translate(919 395)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    strokeWidth: 3.485
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    strokeWidth: 0.5,
    d: "M58.974 54.084c-.066.74-.436 1.418-1.024 1.867-.587.449-1.334.628-2.06.494l-.247-.058h.001c-.754-.212-1.373-.75-1.687-1.472l-2.927-6.659c.348-.201.688-.418 1.022-.649.336-.234.659-.483.968-.745l5.164 5.113c.565.548.854 1.322.79 2.108h0zm-16.998-6.215c-3.115-.562-5.878-2.349-7.682-4.965-1.806-2.618-2.502-5.85-1.936-8.986.566-3.133 2.346-5.914 4.95-7.723 1.985-1.394 4.346-2.142 6.766-2.142.722-.002 1.442.065 2.15.194 4.19.764 7.656 3.722 9.095 7.759 1.437 4.037.627 8.539-2.126 11.81-2.752 3.273-7.028 4.817-11.217 4.053h0zm12.518-2.42c2.772-3.11 4.024-7.301 3.42-11.437-.605-4.133-3.003-7.784-6.547-9.959-3.543-2.174-7.862-2.649-11.789-1.294-3.924 1.354-7.049 4.398-8.524 8.304-1.474 3.905-1.147 8.27.892 11.91 2.04 3.64 5.581 6.176 9.664 6.922.833.153 1.678.231 2.525.231 1.73.002 3.445-.326 5.055-.963l2.903 6.617h-.002c.563 1.28 1.664 2.24 3.003 2.617.144.042.287.074.434.098v.002c.272.048.546.074.822.074 1.892-.006 3.594-1.163 4.306-2.928.713-1.764.296-3.789-1.054-5.123l-5.108-5.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    strokeWidth: 0.5,
    d: "M30.013 52.284v5.55l-5.96-5.913h5.594c.2 0 .361.161.361.36l.005.003zm-.192 8.271c.195.194.459.302.734.302h14.958c1.61 0 2.916-1.295 2.916-2.895v-4.048c0-.57-.466-1.034-1.042-1.034-.574 0-1.04.464-1.04 1.034v4.037c0 .218-.089.43-.245.585-.156.155-.367.242-.589.242H32.08v-6.497c-.003-1.333-1.09-2.414-2.432-2.415h-6.565V28.323c0-.457.373-.827.833-.827h4.49c.575 0 1.042-.463 1.042-1.034s-.467-1.033-1.042-1.033h-4.49c-1.61 0-2.915 1.295-2.915 2.894v23.06c0 .273.11.534.304.728l8.517 8.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    strokeWidth: 0.5,
    d: "M52.988 35.919v-3.747c0-.569-.462-1.03-1.033-1.03h-3.757c-.572 0-1.038.463-1.038 1.035 0 .57.466 1.034 1.038 1.034h1.245l-3.67 3.667-3.245-3.234c-.404-.401-1.057-.401-1.461 0l-4.886 4.864c-.202.191-.319.456-.324.734-.003.278.106.546.303.743.198.197.467.305.746.3.28-.003.545-.119.736-.321l4.151-4.136 3.247 3.235c.403.402 1.056.402 1.46 0l4.425-4.404v1.24c0 .57.463 1.034 1.037 1.034.573 0 1.038-.463 1.038-1.033l-.012.019z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReports);
export default __webpack_public_path__ + "static/media/no-reports.e17e3be3a09bdf47e6abc530af527a24.svg";
export { ForwardRef as ReactComponent };